import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { LanguageProvider } from "./contexts/LanguageContext";

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

// Dynamic Favicon from settings logo
function DynamicFavicon() {
  useEffect(() => {
    axios.get(`${API_BASE}/settings`).then(res => {
      const logo = res.data?.logoImage;
      if (logo) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
        link.href = logo;
      }
    }).catch(() => {});
  }, []);
  return null;
}
import { AuthProvider } from "./contexts/AuthContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import Apply from "./pages/Apply";
import Contact from "./pages/Contact";
import News from "./pages/News";
import About from "./pages/About";
import Admin from "./pages/Admin";
import Register from "./pages/Register";
import MyPage from "./pages/MyPage";
import CertificateProposal from "./pages/CertificateProposal";
import Verify from "./pages/Verify";
import CourseWatch from "./pages/CourseWatch";
import VerifyEmail from "./pages/VerifyEmail";
import LegalPage from "./pages/LegalPage";
import RecruitmentPage from "./pages/RecruitmentPage";
import MembershipPage from "./pages/MembershipPage";
import ReportsPage from "./pages/ReportsPage";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Layout component to conditionally show Navbar/Footer
function Layout({ children }) {
  const location = useLocation();
  const isFullscreenPage = location.pathname.startsWith('/watch/');
  
  if (isFullscreenPage) {
    return <>{children}</>;
  }
  
  return (
    <>
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App min-h-screen flex flex-col">
          <BrowserRouter>
            <DynamicFavicon />
            <ScrollToTop />
            <Layout>
              <ErrorBoundary>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/courses/:id" element={<CourseDetail />} />
                <Route path="/apply" element={<Apply />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/news" element={<News />} />
                <Route path="/news/:id" element={<News />} />
                <Route path="/about" element={<About />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/register" element={<Register />} />
                <Route path="/mypage" element={<MyPage />} />
                <Route path="/proposal/certificate" element={<CertificateProposal />} />
                <Route path="/verify/:certificateNumber" element={<Verify />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/watch/:courseId" element={<CourseWatch />} />
                <Route path="/recruitment" element={<RecruitmentPage />} />
                <Route path="/membership" element={<MembershipPage />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/privacy" element={<LegalPage />} />
                <Route path="/commercial-law" element={<LegalPage />} />
                <Route path="/sustainability" element={<LegalPage />} />
              </Routes>
              </ErrorBoundary>
            </Layout>
          </BrowserRouter>
          <Toaster position="top-right" />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
